var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid justify-content-center"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('team-members')],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('team-settings')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }